import Swal, { SweetAlertOptions } from "sweetalert2";
import imagen from "../../../../assets/img/fotos.png";

const Imagenes = ({ form, setForm }: any) => {
  const onChange = (e: any) => {
    switch (e.target.name) {
      case "images":
        {
          const images = form.IMAGES;
          for (let index = 0; index < e.target.files.length; index++) {
            if (index <= 4 && form.IMAGES.length <= 5) {
              if (e.target.files[index].size > 10000000) {
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                  },
                } as SweetAlertOptions);

                return Toast.fire({
                  icon: "warning",
                  title: "La imagen paso el limite de peso",
                });
              } else {
                const image = {
                  id: null,
                  url: URL.createObjectURL(e.target.files[index]),
                  file: e.target.files[index],
                  imagetable_type: "",
                  imagetable_id: null,
                  created_at: "",
                };
                images.push(image);
              }
            }
          }

          setForm({
            ...form,
            IMAGES: images,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "image-delete":
        {
          delete form.IMAGES[value];
          const images = form.IMAGES.filter((i: any) => i! != null);
          setForm({
            ...form,
            IMAGES: images,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="grid lg:grid-cols-2  gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Agregá algunas fotos
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span>
            Para comenzar, vas a necesitar 5 fotos. Podés agregar otras más o
            hacer cambios más adelante.
          </span>

          <label className="border-dashed px-5 py-5 border border-black items-center ">
            <img src={imagen} alt="" className="mx-auto" width={200} />
            <div className="text-center my-4">
              <span className="block font-bold">
                Seleccioná por lo menos 5 fotos
              </span>
              <span className="border border-black border-s-0 border-t-0 border-e-0">
                Subilas desde tu dispositivo
              </span>
            </div>
            <input
              className="hidden"
              type="file"
              name="images"
              onChange={(event) => onChange(event)}
              multiple
            />
          </label>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {form.IMAGES.length > 0
          ? form.IMAGES.map((im: { url: string }, index: number) => (
              <label
                className="
              group
              cursor-pointer 
              overflow-hidden 
              p-0 
              h-[300px]
              hover:opacity-[0.9]
              hover:scale-110 transition-transform duration-300
              relative
              "
                title="Eliminar"
              >
                <img
                  src={im.url}
                  alt=""
                  className="w-full h-full"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
                <span
                  className="absolute text-white opacity-[0] 
                group-hover:opacity-[1]"
                  style={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 4,
                  }}
                >
                  Eliminar
                </span>
                <button
                  className="hidden"
                  name="image-delete"
                  onClick={(event) => onClick(event, index)}
                ></button>
              </label>
            ))
          : null}
      </div>
    </div>
  );
};

export default Imagenes;
